import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-shrink-0 w-56 md:w-64">
            <img
              src={appData.image}
              alt="木瓜影视移动端观影"
              className="w-full h-auto rounded-2xl"
              loading="lazy"
              width="600"
              height="800"
            />
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              移动观影
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              {appData.subtitle}
            </p>
            <div className="mt-6 grid grid-cols-2 gap-3">
              {appData.features.map((feat, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-2 px-3 py-2.5 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">{feat}</span>
                </div>
              ))}
            </div>
            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-2-line text-lg"></i>
                下载移动端
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-smartphone-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}